import { Photo } from './brick/photo';
import { Price } from './brick/price';
import { ShortDescription } from './brick/short-description';
import { Features } from './brick/features';

export function SidebarSmall({
  url,
  photos,
  price,
  currency,
  priceUnit,
  status,
  term,
  type,
  suburb,
  bedrooms,
  bathrooms,
  garages,
  openParking,
  coveredParking,
  floorSize,
  landSize,
}) {
  return (
    <a
      className={`property-card property-card_type_sidebar property-card_size_small`}
      href={url}
      target={`_blank`}
    >
      <Photo url={photos[0]} />

      <div className={`property-card__details`}>
        <Price
          price={price}
          currency={currency}
          priceUnit={priceUnit}
          status={status}
          term={term}
        />

        <ShortDescription
          type={type}
          status={status}
          suburb={suburb}
        />

        <Features
          bedrooms={bedrooms}
          bathrooms={bathrooms}
          garages={garages}
          openParking={openParking}
          coveredParking={coveredParking}
          floorSize={floorSize}
          landSize={landSize}
        />
      </div>
    </a>
  );
}
